import { EnumBookerCustomizationsSectionOrder as BookerSection, Maybe } from "gql/generated";

export { BookerSection };

export const DEFAULT_SECTION_ORDER: BookerSection[] = [
  BookerSection.Product,
  BookerSection.Questionnaire,
  BookerSection.CustomerDetails,
  BookerSection.Operator,
  BookerSection.AddOns,
  BookerSection.Delivery,
];

/**
 * The admin's saved order, with unknown entries dropped and any section the
 * save doesn't mention slotted back in at its default position. An empty save
 * yields the default order.
 */
export const resolveSectionOrder = (
  saved?: Maybe<Maybe<BookerSection>[]>,
): BookerSection[] => {
  const known = new Set(DEFAULT_SECTION_ORDER);
  const order = Array.from(
    new Set((saved ?? []).filter((s): s is BookerSection => !!s && known.has(s))),
  );
  DEFAULT_SECTION_ORDER.forEach((section, defaultIndex) => {
    if (order.includes(section)) return;
    // Place it before the earliest section that normally follows it.
    const laterPositions = DEFAULT_SECTION_ORDER.slice(defaultIndex + 1)
      .map(s => order.indexOf(s))
      .filter(i => i >= 0);
    order.splice(
      laterPositions.length > 0 ? Math.min(...laterPositions) : order.length,
      0,
      section,
    );
  });
  return order;
};

export const isDefaultSectionOrder = (order: BookerSection[]) =>
  order.length === DEFAULT_SECTION_ORDER.length &&
  order.every((section, i) => section === DEFAULT_SECTION_ORDER[i]);
